import { useTranslation } from "react-i18next";
import { PageLoader } from "UIPalette/PageLoader/PageLoader";
import PageModal from "UIPalette/PageModal/PageModal";

export const JournalLoader = () => {
  const { t } = useTranslation();

  return (
    <PageModal showMobileIcon={false} hideBackForDesktop>
      <div className="lg:mt-16 h-full w-full">
        <PageLoader title={t("positiveYou.loadingMessage")} />
      </div>
    </PageModal>
  );
};
